import type { Profile } from '@/types/profile'

/**
 * New auth users get a provisional username `user_` + first 8 hex chars of their UUID.
 * Once they pick a real username, they no longer match this pattern.
 */
const PROVISIONAL_USERNAME = /^user_[0-9a-f]{8}$/i

export function isProvisionalProfileUsername(username: string): boolean {
  return PROVISIONAL_USERNAME.test(username)
}

export function profileNeedsCompletion(
  profile: Pick<Profile, 'username' | 'profile_setup_completed'> | null | undefined,
): boolean {
  if (!profile) return true
  if (profile.profile_setup_completed === true) return false
  if (profile.profile_setup_completed === false) return true
  // Cached/persisted shapes before column existed — fall back to provisional username only
  if (!profile.username) return true
  return isProvisionalProfileUsername(profile.username)
}
